import { Injectable, inject } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { ProductNames } from '@mynexus/mynexus-ui-lib';
import {
  GlobalBroadcastService,
  IMfeService,
  ISharedServices,
  MessageCallback
} from '@mynexus/mfe-core';
import { ElementRegistryService } from './element-registry.service';
import { MfeRegistryService } from './mfe-registry.service';
import { AuthenticationService } from '@core/authentication/services/authentication.service';
import { API_URL, API_PLATFORM_URL } from '@core/config/api-base-url';

@Injectable({
  providedIn: 'root'
})
export class SharedService implements ISharedServices {
  authenticationService: any = inject(AuthenticationService);
  broadcastService = inject(GlobalBroadcastService);
  elementRegistryService = inject(ElementRegistryService);
  router = inject(Router);
  private mfeRegistryService = inject(MfeRegistryService);
  private apiBaseUrl = inject(API_URL);
  private apiBasePlatformUrl = inject(API_PLATFORM_URL);

  private tenantId?: string;

  constructor() {
    this.router.events
      .pipe(
        filter((event): event is NavigationEnd => event instanceof NavigationEnd)
      )
      .subscribe(() => {
        const urlSegments = this.router.url.split('/');
        const tIdIndex = urlSegments.indexOf('tId');
        if (tIdIndex !== -1 && urlSegments.length > tIdIndex + 1) {
          this.tenantId = urlSegments[tIdIndex + 1];
        }
      });
  }

  broadcastMessage(_topic: string, _message: any): void {
    throw new Error('Method not implemented.');
  }

  getMfeService(appName: string): IMfeService {
    return this.mfeRegistryService.getMfeService(appName);
  }

  registerMfeService(appName: string, service: IMfeService): void {
    this.mfeRegistryService.registerMfeService(appName, service);
  }

  getAuthenticationHeader() {
    const token = this.authenticationService.user?.idToken;
    return {
      name: 'Authorization',
      value: `Bearer ${token || ''}`
    };
  }

  getAppName(): any {
    return 'CodeManagement';
  }

  getBaseUrlFor(appName: string = this.getAppName()): string | never {
    if (appName) return this.getBaseApiUrl(appName);
    throw new Error('Unable to detect application name');
  }

  getTenantId(): string {
    return this.tenantId || '';
  }

  private getBaseApiUrl(appName: string): string {
    const urls: Record<string, string> = {
      CodeManagement: this.apiBaseUrl,
      Platform: this.apiBasePlatformUrl,
      FormIO: this.apiBaseUrl
    };

    return urls[appName]?.replace(/\/$/, '') || this.apiBaseUrl;
  }

  subscribeToTopic(_topic: string, _callback: MessageCallback): void {
    throw new Error('Method not implemented.');
  }

  unsubscribeFromTopic(_topic: string, _callback: MessageCallback): void {
    throw new Error('Method not implemented.');
  }
}
